module.exports = __webpack_public_path__ + "static/media/white-ico-alert-modal-error.a9fb188c.svg";